export const AVATAR_SLUGS = [
  'hedgehog',
  'armadillo',
  'squirrel',
  'turtle',
  'mountain-lion',
  'bison',
  'gazelle',
  'camel',
  'fennec-fox',
  'antelope',
  'lizard',
  'meerkat',
  'wolf',
  'donkey',
  'alpaca',
] as const;

export type AvatarSlug = (typeof AVATAR_SLUGS)[number];

export interface AffiliationEmail {
  value: string;
}

export interface Affiliation {
  id: string;
  institution: string;
  location: string;
  emails: AffiliationEmail[];
  active?: boolean;
  primary?: boolean;
}

export interface Profile {
  username: string;
  fullName: string;
  email: string;
  avatar: AvatarSlug;
  /** Relative API path to a custom uploaded avatar; when present it overrides the preset slug. */
  avatarUrl?: string | null;
  homeLocation?: string | null;
  homeTimezone?: string | null;
  currentLocation?: string | null;
  currentTimezone?: string | null;
  autoTimezone?: boolean;
  /** Capability rung levels. `null` means never chosen — see `resolveStoredCapabilities`. */
  capabilities?: Record<string, number> | null;
  affiliations: Affiliation[];
}
